import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch, useSelector } from "react-redux";
import Navbar from "../Component/navbar";
import "./caursalPage.css";
import { API_URL } from "../apiConfig";
import CSRFToken from "../cookies.js";
import {
  FaEllipsisH,
  FaArrowAltCircleLeft,
  FaArrowAltCircleRight,
} from "react-icons/fa";
import Alert from "@mui/material/Alert";
import { PDFExport } from "@progress/kendo-react-pdf";
import Template1 from "../Component/Template1";
import Template2 from "../Component/Template2";
import Template3 from "../Component/Template3";
import Employee from "../image/Employee.png";
import planExpire from "../image/plan_expired.png";
import downloadingGif from "../image/downloading.gif";
import Footer from "../Component/footer.jsx";
import TYPE from "../reducer/Type.js";

const arrayToString = (array) => {
  if (!Array.isArray(array)) return array;
  return array.join(", ");
};

// const IconButton = ({ icon: Icon, text, onClick }) => (
//   <button onClick={onClick} className="flex items-center px-4 py-2 text-lg font-medium text-white transition duration-200 rounded-md cursor-pointer w-fit">
//     <Icon className="mr-2" />
//     {text}
//   </button>
// );

function Dashboard({ isAuthenticated }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector((state) => state.AuthReducer.user);

  const [dashboardData, setDashboardData] = useState(null);
  const [plan_expire, setPlan_expire] = useState(false);
  const [userData, setUserData] = useState(null);
  const [profileData, setProfileData] = useState(null);
  // const [hoveredIndex, setHoveredIndex] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const imageContainerRef = useRef(null);
  const [userLimit, setUserLimit] = useState(null);
  const [visibleMenuIndex, setVisibleMenuIndex] = useState(null);

  // const pdfExportComponent = useRef(null);
  const [isDownloading, setIsDownloading] = useState(false);
  const pdfRefs = useRef([]);

  const prev = () => (imageContainerRef.current.scrollLeft -= 250);
  const next = () => (imageContainerRef.current.scrollLeft += 250);

  // const handleMouseEnter = (index) => {
  //   setHoveredIndex(index);
  // };

  // const handleMouseLeave = () => {
  //   setHoveredIndex(null);
  // };

  // // FETCH USER INFO
  const fetchUserProfile = async () => {
    try {
      const authToken = localStorage.getItem("access");

      const response = await fetch(`${API_URL}/fetch-user-profile`, {
        method: "GET",
        headers: {
          "X-CSRFToken": CSRFToken(document.cookie),
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = await response.json();

      dispatch({
        type: TYPE.GET_USER_SUCCESS,
        payload: {
          user: data,
        },
      });
      return;
    } catch (error) {
      console.log(error);
    }
  };

  const handleOpenResume = async (resume_id) => {
    if (userLimit > 0) {
      try {
        const authToken = localStorage.getItem("access");

        const response = await fetch(`${API_URL}/user_check`, {
          method: "POST",
          headers: {
            "X-CSRFToken": CSRFToken(document.cookie),
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
          body: JSON.stringify({ res_id: resume_id }),
        });

        if (response.status === 200) {
          const data = await response.json();
          navigate("/Template", {
            state: { resumeId: resume_id },
            state: { outputData: data.output },
          });
        } else {
          console.error("Error:", response.statusText);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    } else {
      setPlan_expire(true);
    }
  };

  const handleCreateBlankResume = async () => {
    if (dashboardData == null || userLimit >= 0) {
      try {
        const authToken = localStorage.getItem("access");

        const response = await fetch(`${API_URL}/create_resume`, {
          method: "POST",
          headers: {
            "X-CSRFToken": CSRFToken(document.cookie),
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });

        if (response.status === 201) {
          const data = await response.json();
          navigate("/Template", { state: { outputData: data.output } });
        } else {
          console.error("Error:", response.statusText);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    } else if (userLimit <= dashboardData.length) {
      setPlan_expire(true);
    }
  };

  const handleCreateResumeWithAI = () => {
    // navigate("/CreateResume");
    if (dashboardData == null) {
      navigate("/create-resume");
    } else if (userLimit > 0) {
      navigate("/create-resume");
    } else if (userLimit <= 0) {
      setPlan_expire(true);
    }
  };

  const handleCancel = () => {
    setPlan_expire(false);
  };

  const handleUpgrade = () => {
    navigate("/pricing");
  };

  const fetchDashboardData = async () => {
    try {
      const authToken = localStorage.getItem("access");

      if (!authToken) {
        navigate("/login");
        return;
      }

      const response = await fetch(`${API_URL}/fetch_all`, {
        method: "POST",
        headers: {
          "X-CSRFToken": CSRFToken(document.cookie),
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (response.status === 401) {
        navigate("/login");
        return;
      }
      if (response.status === 404) {
        const data = await response.json();

        dispatch({
          type: TYPE.GET_USER_DETAILS_SUCCESS,
          payload: {
            userDetails: data,
          },
        });

        setUserData(`${data.user_data?.first_name}`);
        setProfileData(data.user_data?.profile_pic);
        setUserLimit(data.user_data?.available_token);
        return;
      }

      const data = await response.json();
      dispatch({
        type: TYPE.GET_USER_DETAILS_SUCCESS,
        payload: {
          userDetails: data,
        },
      });
      setDashboardData(data.output);
      setUserData(`${data.user_data?.first_name}`);
      setProfileData(data.user_data?.profile_pic);
      setUserLimit(data.user_data?.available_token);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    fetchUserProfile();
  }, []);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  if (!isAuthenticated) {
    const storedToken = localStorage.getItem("access");
    if (storedToken) {
      navigate("/login");
    }
    return null;
  }
  const handlePfp = () => {
    navigate("/profile");
  };

  const handleMenuToggle = (index) => {
    setVisibleMenuIndex(visibleMenuIndex === index ? null : index);
  };

  // const handleMenuClose = () => {
  //   setVisibleMenuIndex(null);
  // };

  const exportPDF = async (index) => {
    setVisibleMenuIndex(null);
    if (!isDownloading) {
      // Prevent multiple simultaneous downloads
      setIsDownloading(true); // Set isDownloading to true

      const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

      // Wait for 2 seconds
      await wait(2000);

      if (pdfRefs.current[index]) {
        pdfRefs.current[index].save();
      }

      setIsDownloading(false); // Set isDownloading to false after download is complete
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-white">
      {isDownloading && (
        <div className="download-overlay">
          <img
            src={downloadingGif}
            alt="Downloading"
            className="download-overlay-gif"
          />
          <span className="download-overlay-text">Downloading...</span>
        </div>
      )}
      <Navbar />
      {plan_expire && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
          <div className="flex flex-col px-4 items-center w-[550px] h-[445px] rounded-2xl bg-white">
            <img src={planExpire} className="w-[50%]" alt="plan" />
            <p className="text-2xl font-semibold">
              Limit exceeded, No active plan.
            </p>
            <p className="mx-4 my-2 text-base text-center">
              You can download your resumes. Reactivate your plan to edit your
              resumes.
            </p>
            <div className="flex w-full gap-2 px-8 mx-4 mt-4">
              <button
                className="flex-1 py-2 text-sm font-semibold border-black rounded-md h-fit border-1"
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button
                className="flex-1 py-2 text-sm font-semibold text-white bg-orange-500 rounded-md h-fit border-1"
                onClick={handleUpgrade}
              >
                Upgrade Plan
              </button>
            </div>
          </div>
        </div>
      )}
      {showAlert && (
        <Alert className="mx-32 mt-2" severity="warning">
          Maximum limit of resumes exceeded!
        </Alert>
      )}

      {user && user?.user && (
        <div className="flex flex-wrap items-center mx-6 mt-12 mb-4 dash_user_data sm:mx-32">
          <img
            src={profileData || Employee}
            alt="profile"
            className="w-20 h-20 p-1 border-2 rounded-full cursor-pointer"
            onClick={handlePfp}
          />
          <p className="ml-4 font-serif text-3xl font-semibold">
            Welcome {user?.user?.first_name}!
          </p>
        </div>
      )}

      <div className="dash_main_card relative bg-[#FFE8D9] rounded-3xl min-h-[450px] mx-6 sm:mx-32 mb-16 sm:mb-16">
        <div className="dash_card_header flex text-4xl justify-between font-semibold px-4 pt-4 mx-3 text-[#1D6362]">
          Dashboard
          <button
            onClick={handleCreateResumeWithAI}
            className="text-lg font-medium text-white bg-[#ed6f2d] px-2 py-1 mr-2 rounded-md"
          >
            Create New
          </button>
        </div>

        <div className="grid grid-cols-1 mt-2 lg:grid-cols-2 sm:">
          <div className="m-auto w-96">
            <div className="bg-white text-xl px-3 py-3 my-3 mx-3 rounded-2xl shadow-xl text-center text-[#1D6362] font-semibold">
              <button onClick={handleCreateResumeWithAI}>
                Create Resume with AI
              </button>
            </div>
            <div className="bg-white text-xl px-2 py-3 my-3 mx-3 rounded-2xl shadow-xl text-center text-[#1D6362] font-semibold">
              <button onClick={handleCreateBlankResume}>
                Create Blank Resume
              </button>
            </div>
            <div className="bg-white text-xl px-2 py-3 my-3 mx-3 rounded-2xl shadow-xl text-center text-[#1D6362] font-semibold">
              Import from Linkedin
            </div>
            <div className="bg-white text-xl px-2 py-3 my-3 mx-3 rounded-2xl shadow-xl text-center text-[#1D6362] font-semibold">
              Re-use a Resume
            </div>
          </div>

          {dashboardData && dashboardData.length > 0 ? (
            <div className="page-container">
              <div className="content">
                <div className="prev" onClick={prev}></div>
                <div className="slide-panel" ref={imageContainerRef}>
                  {dashboardData.map((item, index) => {
                    const formData = {
                      res_id: item.res_id,
                      res_title: item?.resume_sample_title,
                      edu_flag: true,
                      Work_flag: true,
                      ach_flag: true,
                      add_flag: true,
                      skill_flag: true,
                      pro_flag: true,
                      Details:
                        item?.name ||
                        item?.email ||
                        item?.phone ||
                        item?.linkedin ||
                        item?.github ||
                        item?.summary
                          ? [
                              {
                                fullName: item?.name || "",
                                email: item?.email || "",
                                phoneNumber: item?.phone || "",
                                address: "",
                                website: "",
                                linkedin: item?.linkedin || "",
                                github: item?.github || "",
                                about: item?.summary || "",
                              },
                            ]
                          : [],
                      education: item?.education || [],
                      experience:
                        item?.experience.map((exp) => {
                          let jobDescriptionHTML = "";
                          if (Array.isArray(exp.responsibilities)) {
                            jobDescriptionHTML = exp.responsibilities
                              .map(
                                (responsibility) => `<li>${responsibility}</li>`
                              )
                              .join("");
                            jobDescriptionHTML = `<ul>${jobDescriptionHTML}</ul>`;
                          } else {
                            jobDescriptionHTML = exp.responsibilities;
                          }
                          return {
                            jobRole: exp.job_role || "",
                            companyName: exp.company_name || "",
                            companyLocation: exp.job_location || "",
                            fromYear: exp.from_date || "",
                            toYear: exp.to_date || "",
                            jobDescription: jobDescriptionHTML,
                          };
                        }) || [],
                      skills:
                        item?.skills.map((skill) => ({
                          title: skill.skill_title || "",
                          skill_list: arrayToString(skill.skill_list) || "",
                        })) || [],
                      achivawards: item?.awards_achievements || [],
                      addinfodatas:
                        item?.additionalInfo.map((info) => ({
                          addinfodata: info.add_info,
                        })) || [],
                      addprojects:
                        item?.projects.map((proj) => {
                          let descriptionHTML = "";
                          if (Array.isArray(proj.project_description)) {
                            descriptionHTML = proj.project_description
                              .map((desc) => `<li>${desc}</li>`)
                              .join("");
                            descriptionHTML = `<ul>${descriptionHTML}</ul>`;
                          } else {
                            descriptionHTML = proj.project_description;
                          }
                          return {
                            projectname: proj.project_title || "",
                            projectplatform:
                              arrayToString(proj.project_techStack) || "",
                            description: descriptionHTML,
                          };
                        }) || [],
                      profileImage: "",
                    };
                    //console.log('formData:', formData); // Log formData for debugging
                    return (
                      <div key={index} className="slide-item">
                        <div className="relative w-full h-full mx-2 text-center bg-white rounded-2xl hover:shadow-xl">
                          <div
                            className="res_image_sec"
                            onClick={() => handleOpenResume(item.res_id)}
                          >
                            <>
                              <PDFExport
                                ref={(el) => (pdfRefs.current[index] = el)}
                                paperSize="A4"
                                fileName={
                                  userData +
                                  `_Resume${new Date().getFullYear()}`
                                }
                                author="https://esumeBeen.com"
                              >
                                <div
                                  className={`dash_in  ${
                                    isDownloading ? "resume-visible" : ""
                                  }`}
                                >
                                  <div className="dash_transformer">
                                    {/* Render the template component directly */}
                                    {item.template_key === "template1" && (
                                      <Template1 formData={formData} />
                                    )}
                                    {item.template_key === "template2" && (
                                      <Template2 formData={formData} />
                                    )}
                                    {item.template_key === "template3" && (
                                      <Template3 formData={formData} />
                                    )}
                                  </div>
                                </div>
                              </PDFExport>
                            </>
                          </div>
                          <div className="bottom_section">
                            {item.resume_sample_title ? (
                              <p className="text-xs font-normal text-left text-gray-600">
                                {item.resume_sample_title.length > 20
                                  ? `${item.resume_sample_title.slice(
                                      0,
                                      20
                                    )}...`
                                  : item.resume_sample_title}
                              </p>
                            ) : (
                              <p className="text-xs font-normal text-left text-gray-600">
                                Untitled
                              </p>
                            )}
                            {/* <FaEllipsisH className="text-base text-black" /> */}

                            <FaEllipsisH
                              onClick={() => handleMenuToggle(index)}
                              className="text-lg cursor-pointer"
                            />
                            {visibleMenuIndex === index && (
                              <div className="absolute right-0 z-10 w-40 mt-2 bg-white border rounded-md shadow-md bottom-10">
                                <span
                                  onClick={() => exportPDF(index)}
                                  className="block px-4 py-2 text-sm text-gray-800 border-b-2 cursor-pointer hover:bg-gray-200"
                                >
                                  Download
                                </span>
                                <span className="block px-4 py-2 text-sm text-gray-800 cursor-pointer hover:bg-gray-200">
                                  Rename
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="next" onClick={next}></div>
              </div>
              <div className="bottom_slider_btn">
                <div className="text-xl back" onClick={prev}>
                  <FaArrowAltCircleLeft />
                </div>
                <div className="text-xl righter" onClick={next}>
                  <FaArrowAltCircleRight />
                </div>
              </div>
            </div>
          ) : (
            <div className="relative w-2/5 h-auto mx-2 my-5">
              <div className="text-5xl font-semibold text-neutral-800">
                {" "}
                Build your successful resume instantly using AI
              </div>
              <section
                onClick={handleCreateResumeWithAI}
                className="flex self-start gap-3 px-6 py-2 my-12 text-white transition-colors duration-1000 border border-black bg-slate-700 w-60 rounded-xl hover:bg-orange-400 max-md:px-5 "
              >
                <p className="my-auto">Create AI resume</p>
                <img
                  loading="lazy"
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/a74201ba4b9995e3135082ffa342eda686314d8dcf9e25310a286f8b8f4622f7?apiKey=e64c88474a2c4290b8b66f50b4a39c22&"
                  alt=""
                  className="w-8 shrink-0 aspect-square"
                />
              </section>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.AuthReducer.isAuthenticated,
  };
};

export default connect(mapStateToProps)(Dashboard);
